import { render, staticRenderFns } from "./TrainingOrderDetail.vue?vue&type=template&id=228061d4&scoped=true&"
import script from "./TrainingOrderDetail.vue?vue&type=script&lang=js&"
export * from "./TrainingOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainingOrderDetail.vue?vue&type=style&index=0&id=228061d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228061d4",
  null
  
)

export default component.exports